// src/components/Footer.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="py-4">
            <Container>
                <Row>
                    <Col className="text-center">
                        <div className="brand-logo justify-content-center mb-3">
                            <div className="brand-icon">
                                <span className="brand-letter">H</span>
                            </div>
                            <span className="logo-text">HashControl</span>
                        </div>
                        <p className="mb-0 text-secondary">
                            hashcontrol.online &copy; {new Date().getFullYear()} | {t('dashboard.effectiveManagement')}
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;